import { Component, OnInit, AfterViewInit, EventEmitter, QueryList, ViewChildren, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { IssuesRest } from '../../issues.rest';
import { ObjectToSelect } from '../../../core/shared/objectToSelect.model';
import { RichTextComponent } from '../../../core/shared/richtext/richtext.component';
import { DialogControl } from '../../../core/shared/dialog/dialog.model';
import { INgxSelectOption } from 'ngx-select-ex';

@Component({
  selector: 'app-issues-change-state',
  templateUrl: './issues-change-state.component.html',
  styleUrls: ['./issues-change-state.component.scss']
})
export class IssuesChangeStateComponent implements AfterViewInit, OnInit, DialogControl {
  dialogConfigData: any;
  onDialogClose: EventEmitter<any> = new EventEmitter<any>();
  isConfirmButtonDisabled: boolean = false;

  public states: ObjectToSelect[];
  public employees: ObjectToSelect[];
  private selectedIds: any;
  public stateId: any;
  public employeeId: any;
  public isSendEmail: any;
  private descriptionView: RichTextComponent = null;
  @ViewChildren(RichTextComponent) descriptionViews: QueryList<RichTextComponent>;
  @ViewChild('changeStateForm') changeStateForm: NgForm;

  constructor(private rest: IssuesRest) {
    this.descriptionViews = new QueryList<RichTextComponent>();
    this.isSendEmail = true;
  } 

  ngAfterViewInit() {
    this.selectedIds =  this.dialogConfigData.selectedItems;
    this.getDescription();
    this.descriptionViews.notifyOnChanges();
    this.changeStateForm.statusChanges.subscribe(() => {
      this.isConfirmButtonDisabled = this.changeStateForm.invalid;
    });    
  }

  ngOnInit() {
    this.getStates();
    this.getCustomerEmployees(0);
  }

  
  public closeDialog() {
  //  this.descriptionViews.destroy();
    this.onDialogClose.emit();
  }  

  public confirmDialog(){
    this.changeState();
  };

  public getStates() {
    const action = this.rest.getStates;
    action.call(this.rest).subscribe((result: ObjectToSelect[]) => {
        if (result) {
            this.states = result;
        }
    });
  }

  private getDescription() {    
    this.descriptionViews.changes.subscribe((nv: QueryList<RichTextComponent>) => {
        this.descriptionView = nv.first; 
        this.descriptionView.setHtml("");  
    });
  }

  public getCustomerEmployees(customerId: number) {
    const action = this.rest.getCustomerEmployees;
    action.call(this.rest, customerId).subscribe((result: ObjectToSelect[]) => {
        if (result) {
            this.employees = result;
        }
    });
  }

  private searchCallback(search: string, item: INgxSelectOption): boolean {
    search = search.toLowerCase();
    return item.data.name.toLowerCase().includes(search) || item.data.guid.toLowerCase().includes(search);
  }

  changeState()
  {
    if (this.stateId == undefined)
    {
      sweetAlert("Nie określono statusu.");
      return;
    }

    const changeStateEntity = {
      ids: this.selectedIds,
      objectStateId: this.stateId,
      employeeId: this.employeeId,
      isSendEmail: this.isSendEmail,
      description: this.descriptionView.getHtml()
    };

    this.rest.changeStates(changeStateEntity).subscribe((result: boolean) => {
      if (result) {
         
      }
      this.closeDialog();
    });
    
  }
}